export const getLanguagesByAppLanguage = (appLang) => {
  const languageTranslations = {
    es: {
      'auto': 'Detectar idioma',
      'af': 'Afrikáans',
      'sq': 'Albanés',
      'am': 'Amárico',
      'ar': 'Árabe',
      'hy': 'Armenio',
      'az': 'Azerbaiyano',
      'eu': 'Vasco',
      'be': 'Bielorruso',
      'bn': 'Bengalí',
      'bs': 'Bosnio',
      'bg': 'Búlgaro',
      'ca': 'Catalán',
      'ceb': 'Cebuano',
      'ny': 'Chichewa',
      'zh': 'Chino (simplificado)',
      'zh-TW': 'Chino (tradicional)',
      'co': 'Corso',
      'hr': 'Croata',
      'cs': 'Checo',
      'da': 'Danés',
      'nl': 'Holandés',
      'en': 'Inglés',
      'eo': 'Esperanto',
      'et': 'Estonio',
      'tl': 'Filipino',
      'fi': 'Finés',
      'fr': 'Francés',
      'fy': 'Frisón',
      'gl': 'Gallego',
      'ka': 'Georgiano',
      'de': 'Alemán',
      'el': 'Griego',
      'gu': 'Gujarati',
      'ht': 'Criollo haitiano',
      'ha': 'Hausa',
      'haw': 'Hawaiano',
      'iw': 'Hebreo',
      'hi': 'Hindi',
      'hmn': 'Hmong',
      'hu': 'Húngaro',
      'is': 'Islandés',
      'ig': 'Igbo',
      'id': 'Indonesio',
      'ga': 'Irlandés',
      'it': 'Italiano',
      'ja': 'Japonés',
      'jw': 'Javanés',
      'kn': 'Canarés',
      'kk': 'Kazajo',
      'km': 'Jemer',
      'ko': 'Coreano',
      'ku': 'Kurdo',
      'ky': 'Kirguís',
      'lo': 'Lao',
      'la': 'Latín',
      'lv': 'Letón',
      'lt': 'Lituano',
      'lb': 'Luxemburgués',
      'mk': 'Macedonio',
      'mg': 'Malgache',
      'ms': 'Malayo',
      'ml': 'Malayalam',
      'mt': 'Maltés',
      'mi': 'Maorí',
      'mr': 'Maratí',
      'mn': 'Mongol',
      'my': 'Birmano',
      'ne': 'Nepalí',
      'no': 'Noruego',
      'ps': 'Pastún',
      'fa': 'Persa',
      'pl': 'Polaco',
      'pt': 'Portugués',
      'pa': 'Punjabi',
      'ro': 'Rumano',
      'ru': 'Ruso',
      'sm': 'Samoano',
      'gd': 'Gaélico escocés',
      'sr': 'Serbio',
      'st': 'Sesoto',
      'sn': 'Shona',
      'sd': 'Sindhi',
      'si': 'Cingalés',
      'sk': 'Eslovaco',
      'sl': 'Esloveno',
      'so': 'Somalí',
      'es': 'Español', // Removed all Spanish variants
      'su': 'Sundanés',
      'sw': 'Suajili',
      'sv': 'Sueco',
      'tg': 'Tayiko',
      'ta': 'Tamil',
      'te': 'Telugu',
      'th': 'Tailandés',
      'tr': 'Turco',
      'uk': 'Ucraniano',
      'ur': 'Urdu',
      'uz': 'Uzbeko',
      'vi': 'Vietnamita',
      'cy': 'Galés',
      'xh': 'Xhosa',
      'yi': 'Yidis',
      'yo': 'Yoruba',
      'zu': 'Zulú'
    },
    en: {
      'auto': 'Detect language',
      'af': 'Afrikaans',
      'sq': 'Albanian',
      'am': 'Amharic',
      'ar': 'Arabic',
      'hy': 'Armenian',
      'az': 'Azerbaijani',
      'eu': 'Basque',
      'be': 'Belarusian',
      'bn': 'Bengali',
      'bs': 'Bosnian',
      'bg': 'Bulgarian',
      'ca': 'Catalan',
      'ceb': 'Cebuano',
      'ny': 'Chichewa',
      'zh': 'Chinese (simplified)',
      'zh-TW': 'Chinese (traditional)',
      'co': 'Corsican',
      'hr': 'Croatian',
      'cs': 'Czech',
      'da': 'Danish',
      'nl': 'Dutch',
      'en': 'English',
      'eo': 'Esperanto',
      'et': 'Estonian',
      'tl': 'Filipino',
      'fi': 'Finnish',
      'fr': 'French',
      'fy': 'Frisian',
      'gl': 'Galician',
      'ka': 'Georgian',
      'de': 'German',
      'el': 'Greek',
      'gu': 'Gujarati',
      'ht': 'Haitian creole',
      'ha': 'Hausa',
      'haw': 'Hawaiian',
      'iw': 'Hebrew',
      'hi': 'Hindi',
      'hmn': 'Hmong',
      'hu': 'Hungarian',
      'is': 'Icelandic',
      'ig': 'Igbo',
      'id': 'Indonesian',
      'ga': 'Irish',
      'it': 'Italian',
      'ja': 'Japanese',
      'jw': 'Javanese',
      'kn': 'Kannada',
      'kk': 'Kazakh',
      'km': 'Khmer',
      'ko': 'Korean',
      'ku': 'Kurdish',
      'ky': 'Kyrgyz',
      'lo': 'Lao',
      'la': 'Latin',
      'lv': 'Latvian',
      'lt': 'Lithuanian',
      'lb': 'Luxembourgish',
      'mk': 'Macedonian',
      'mg': 'Malagasy',
      'ms': 'Malay',
      'ml': 'Malayalam',
      'mt': 'Maltese',
      'mi': 'Maori',
      'mr': 'Marathi',
      'mn': 'Mongolian',
      'my': 'Myanmar (burmese)',
      'ne': 'Nepali',
      'no': 'Norwegian',
      'ps': 'Pashto',
      'fa': 'Persian',
      'pl': 'Polish',
      'pt': 'Portuguese',
      'pa': 'Punjabi',
      'ro': 'Romanian',
      'ru': 'Russian',
      'sm': 'Samoan',
      'gd': 'Scots gaelic',
      'sr': 'Serbian',
      'st': 'Sesotho',
      'sn': 'Shona',
      'sd': 'Sindhi',
      'si': 'Sinhala',
      'sk': 'Slovak',
      'sl': 'Slovenian',
      'so': 'Somali',
      'es': 'Spanish', // Removed all Spanish variants
      'su': 'Sundanese',
      'sw': 'Swahili',
      'sv': 'Swedish',
      'tg': 'Tajik',
      'ta': 'Tamil',
      'te': 'Telugu',
      'th': 'Thai',
      'tr': 'Turkish',
      'uk': 'Ukrainian',
      'ur': 'Urdu',
      'uz': 'Uzbek',
      'vi': 'Vietnamese',
      'cy': 'Welsh',
      'xh': 'Xhosa',
      'yi': 'Yiddish',
      'yo': 'Yoruba',
      'zu': 'Zulu'
    },
    pt: {
      'auto': 'Detectar idioma',
      'af': 'Africâner',
      'sq': 'Albanês',
      'am': 'Amárico',
      'ar': 'Árabe',
      'hy': 'Armênio',
      'az': 'Azerbaijano',
      'eu': 'Basco',
      'be': 'Bielorrusso',
      'bn': 'Bengali',
      'bs': 'Bósnio',
      'bg': 'Búlgaro',
      'ca': 'Catalão',
      'ceb': 'Cebuano',
      'ny': 'Chichewa',
      'zh': 'Chinês (simplificado)',
      'zh-TW': 'Chinês (tradicional)',
      'co': 'Corso',
      'hr': 'Croata',
      'cs': 'Tcheco',
      'da': 'Dinamarquês',
      'nl': 'Holandês',
      'en': 'Inglês',
      'eo': 'Esperanto',
      'et': 'Estoniano',
      'tl': 'Filipino',
      'fi': 'Finlandês',
      'fr': 'Francês',
      'fy': 'Frísio',
      'gl': 'Galego',
      'ka': 'Georgiano',
      'de': 'Alemão',
      'el': 'Grego',
      'gu': 'Gujarati',
      'ht': 'Crioulo haitiano',
      'ha': 'Hauçá',
      'haw': 'Havaiano',
      'iw': 'Hebraico',
      'hi': 'Hindi',
      'hmn': 'Hmong',
      'hu': 'Húngaro',
      'is': 'Islandês',
      'ig': 'Igbo',
      'id': 'Indonésio',
      'ga': 'Irlandês',
      'it': 'Italiano',
      'ja': 'Japonês',
      'jw': 'Javanês',
      'kn': 'Canarês',
      'kk': 'Cazaque',
      'km': 'Khmer',
      'ko': 'Coreano',
      'ku': 'Curdo',
      'ky': 'Quirguiz',
      'lo': 'Laosiano',
      'la': 'Latim',
      'lv': 'Letão',
      'lt': 'Lituano',
      'lb': 'Luxemburguês',
      'mk': 'Macedônio',
      'mg': 'Malgaxe',
      'ms': 'Malaio',
      'ml': 'Malaiala',
      'mt': 'Maltês',
      'mi': 'Maori',
      'mr': 'Marathi',
      'mn': 'Mongol',
      'my': 'Birmanês',
      'ne': 'Nepalês',
      'no': 'Norueguês',
      'ps': 'Pashto',
      'fa': 'Persa',
      'pl': 'Polonês',
      'pt': 'Português',
      'pa': 'Punjabi',
      'ro': 'Romeno',
      'ru': 'Russo',
      'sm': 'Samoano',
      'gd': 'Gaélico escocês',
      'sr': 'Sérvio',
      'st': 'Sesoto',
      'sn': 'Shona',
      'sd': 'Sindhi',
      'si': 'Cingalês',
      'sk': 'Eslovaco',
      'sl': 'Esloveno',
      'so': 'Somali',
      'es': 'Espanhol', // Removed all Spanish variants
      'su': 'Sundanês',
      'sw': 'Suaíli',
      'sv': 'Sueco',
      'tg': 'Tadjique',
      'ta': 'Tâmil',
      'te': 'Telugu',
      'th': 'Tailandês',
      'tr': 'Turco',
      'uk': 'Ucraniano',
      'ur': 'Urdu',
      'uz': 'Uzbeque',
      'vi': 'Vietnamita',
      'cy': 'Galês',
      'xh': 'Xhosa',
      'yi': 'Iídiche',
      'yo': 'Iorubá',
      'zu': 'Zulu'
    },
    fr: {
      'auto': 'Détecter la langue',
      'af': 'Afrikaans',
      'sq': 'Albanais',
      'am': 'Amharique',
      'ar': 'Arabe',
      'hy': 'Arménien',
      'az': 'Azerbaïdjanais',
      'eu': 'Basque',
      'be': 'Biélorusse',
      'bn': 'Bengali',
      'bs': 'Bosniaque',
      'bg': 'Bulgare',
      'ca': 'Catalan',
      'ceb': 'Cebuano',
      'ny': 'Chichewa',
      'zh': 'Chinois (simplifié)',
      'zh-TW': 'Chinois (traditionnel)',
      'co': 'Corse',
      'hr': 'Croate',
      'cs': 'Tchèque',
      'da': 'Danois',
      'nl': 'Néerlandais',
      'en': 'Anglais',
      'eo': 'Espéranto',
      'et': 'Estonien',
      'tl': 'Filipino',
      'fi': 'Finnois',
      'fr': 'Français',
      'fy': 'Frison',
      'gl': 'Galicien',
      'ka': 'Géorgien',
      'de': 'Allemand',
      'el': 'Grec',
      'gu': 'Gujarati',
      'ht': 'Créole haïtien',
      'ha': 'Haoussa',
      'haw': 'Hawaïen',
      'iw': 'Hébreu',
      'hi': 'Hindi',
      'hmn': 'Hmong',
      'hu': 'Hongrois',
      'is': 'Islandais',
      'ig': 'Igbo',
      'id': 'Indonésien',
      'ga': 'Irlandais',
      'it': 'Italien',
      'ja': 'Japonais',
      'jw': 'Javanais',
      'kn': 'Kannada',
      'kk': 'Kazakh',
      'km': 'Khmer',
      'ko': 'Coréen',
      'ku': 'Kurde',
      'ky': 'Kirghize',
      'lo': 'Lao',
      'la': 'Latin',
      'lv': 'Letton',
      'lt': 'Lituanien',
      'lb': 'Luxembourgeois',
      'mk': 'Macédonien',
      'mg': 'Malgache',
      'ms': 'Malais',
      'ml': 'Malayalam',
      'mt': 'Maltais',
      'mi': 'Maori',
      'mr': 'Marathi',
      'mn': 'Mongol',
      'my': 'Birman',
      'ne': 'Népalais',
      'no': 'Norvégien',
      'ps': 'Pachto',
      'fa': 'Persan',
      'pl': 'Polonais',
      'pt': 'Portugais',
      'pa': 'Punjabi',
      'ro': 'Roumain',
      'ru': 'Russe',
      'sm': 'Samoan',
      'gd': 'Gaélique écossais',
      'sr': 'Serbe',
      'st': 'Sesotho',
      'sn': 'Shona',
      'sd': 'Sindhi',
      'si': 'Cingalais',
      'sk': 'Slovaque',
      'sl': 'Slovène',
      'so': 'Somali',
      'es': 'Espagnol', // Removed all Spanish variants
      'su': 'Soundanais',
      'sw': 'Swahili',
      'sv': 'Suédois',
      'tg': 'Tadjik',
      'ta': 'Tamoul',
      'te': 'Telugu',
      'th': 'Thaï',
      'tr': 'Turc',
      'uk': 'Ukrainien',
      'ur': 'Ourdou',
      'uz': 'Ouzbek',
      'vi': 'Vietnamien',
      'cy': 'Gallois',
      'xh': 'Xhosa',
      'yi': 'Yiddish',
      'yo': 'Yoruba',
      'zu': 'Zoulou'
    },
    de: {
      'auto': 'Sprache erkennen',
      'af': 'Afrikaans',
      'sq': 'Albanisch',
      'am': 'Amharisch',
      'ar': 'Arabisch',
      'hy': 'Armenisch',
      'az': 'Aserbaidschanisch',
      'eu': 'Baskisch',
      'be': 'Weißrussisch',
      'bn': 'Bengali',
      'bs': 'Bosnisch',
      'bg': 'Bulgarisch',
      'ca': 'Katalanisch',
      'ceb': 'Cebuano',
      'ny': 'Chichewa',
      'zh': 'Chinesisch (vereinfacht)',
      'zh-TW': 'Chinesisch (traditionell)',
      'co': 'Korsisch',
      'hr': 'Kroatisch',
      'cs': 'Tschechisch',
      'da': 'Dänisch',
      'nl': 'Niederländisch',
      'en': 'Englisch',
      'eo': 'Esperanto',
      'et': 'Estnisch',
      'tl': 'Filipino',
      'fi': 'Finnisch',
      'fr': 'Französisch',
      'fy': 'Friesisch',
      'gl': 'Galizisch',
      'ka': 'Georgisch',
      'de': 'Deutsch',
      'el': 'Griechisch',
      'gu': 'Gujarati',
      'ht': 'Haitianisches kreol',
      'ha': 'Haussa',
      'haw': 'Hawaiisch',
      'iw': 'Hebräisch',
      'hi': 'Hindi',
      'hmn': 'Hmong',
      'hu': 'Ungarisch',
      'is': 'Isländisch',
      'ig': 'Igbo',
      'id': 'Indonesisch',
      'ga': 'Irisch',
      'it': 'Italienisch',
      'ja': 'Japanisch',
      'jw': 'Javanisch',
      'kn': 'Kannada',
      'kk': 'Kasachisch',
      'km': 'Khmer',
      'ko': 'Koreanisch',
      'ku': 'Kurdisch',
      'ky': 'Kirgisisch',
      'lo': 'Laotisch',
      'la': 'Lateinisch',
      'lv': 'Lettisch',
      'lt': 'Litauisch',
      'lb': 'Luxemburgisch',
      'mk': 'Mazedonisch',
      'mg': 'Madagassisch',
      'ms': 'Malaiisch',
      'ml': 'Malayalam',
      'mt': 'Maltesisch',
      'mi': 'Maori',
      'mr': 'Marathi',
      'mn': 'Mongolisch',
      'my': 'Birmanisch',
      'ne': 'Nepalesisch',
      'no': 'Norwegisch',
      'ps': 'Paschtu',
      'fa': 'Persisch',
      'pl': 'Polnisch',
      'pt': 'Portugiesisch',
      'pa': 'Punjabi',
      'ro': 'Rumänisch',
      'ru': 'Russisch',
      'sm': 'Samoanisch',
      'gd': 'Schottisch-gälisch',
      'sr': 'Serbisch',
      'st': 'Sesotho',
      'sn': 'Shona',
      'sd': 'Sindhi',
      'si': 'Singhalesisch',
      'sk': 'Slowakisch',
      'sl': 'Slowenisch',
      'so': 'Somali',
      'es': 'Spanisch', // Removed all Spanish variants
      'su': 'Sundanesisch',
      'sw': 'Suaheli',
      'sv': 'Schwedisch',
      'tg': 'Tadschikisch',
      'ta': 'Tamil',
      'te': 'Telugu',
      'th': 'Thai',
      'tr': 'Türkisch',
      'uk': 'Ukrainisch',
      'ur': 'Urdu',
      'uz': 'Usbekisch',
      'vi': 'Vietnamesisch',
      'cy': 'Walisisch',
      'xh': 'Xhosa',
      'yi': 'Jiddisch',
      'yo': 'Yoruba',
      'zu': 'Zulu'
    },
    it: {
      'auto': 'Rileva lingua',
      'af': 'Afrikaans',
      'sq': 'Albanese',
      'am': 'Amarico',
      'ar': 'Arabo',
      'hy': 'Armeno',
      'az': 'Azero',
      'eu': 'Basco',
      'be': 'Bielorusso',
      'bn': 'Bengali',
      'bs': 'Bosniaco',
      'bg': 'Bulgaro',
      'ca': 'Catalano',
      'ceb': 'Cebuano',
      'ny': 'Chichewa',
      'zh': 'Cinese (semplificato)',
      'zh-TW': 'Cinese (tradizionale)',
      'co': 'Corso',
      'hr': 'Croato',
      'cs': 'Ceco',
      'da': 'Danese',
      'nl': 'Olandese',
      'en': 'Inglese',
      'eo': 'Esperanto',
      'et': 'Estone',
      'tl': 'Filipino',
      'fi': 'Finlandese',
      'fr': 'Francese',
      'fy': 'Frisone',
      'gl': 'Galiziano',
      'ka': 'Georgiano',
      'de': 'Tedesco',
      'el': 'Greco',
      'gu': 'Gujarati',
      'ht': 'Creolo haitiano',
      'ha': 'Hausa',
      'haw': 'Hawaiano',
      'iw': 'Ebraico',
      'hi': 'Hindi',
      'hmn': 'Hmong',
      'hu': 'Ungherese',
      'is': 'Islandese',
      'ig': 'Igbo',
      'id': 'Indonesiano',
      'ga': 'Irlandese',
      'it': 'Italiano',
      'ja': 'Giapponese',
      'jw': 'Giavanese',
      'kn': 'Kannada',
      'kk': 'Kazako',
      'km': 'Khmer',
      'ko': 'Coreano',
      'ku': 'Curdo',
      'ky': 'Kirghiso',
      'lo': 'Lao',
      'la': 'Latino',
      'lv': 'Lettone',
      'lt': 'Lituano',
      'lb': 'Lussemburghese',
      'mk': 'Macedone',
      'mg': 'Malgascio',
      'ms': 'Malese',
      'ml': 'Malayalam',
      'mt': 'Maltese',
      'mi': 'Maori',
      'mr': 'Marathi',
      'mn': 'Mongolo',
      'my': 'Birmano',
      'ne': 'Nepalese',
      'no': 'Norvegese',
      'ps': 'Pashto',
      'fa': 'Persiano',
      'pl': 'Polacco',
      'pt': 'Portoghese',
      'pa': 'Punjabi',
      'ro': 'Rumeno',
      'ru': 'Russo',
      'sm': 'Samoano',
      'gd': 'Gaelico scozzese',
      'sr': 'Serbo',
      'st': 'Sesotho',
      'sn': 'Shona',
      'sd': 'Sindhi',
      'si': 'Singalese',
      'sk': 'Slovacco',
      'sl': 'Sloveno',
      'so': 'Somalo',
      'es': 'Spagnolo', // Removed all Spanish variants
      'su': 'Sundanese',
      'sw': 'Swahili',
      'sv': 'Svedese',
      'tg': 'Tagico',
      'ta': 'Tamil',
      'te': 'Telugu',
      'th': 'Thai',
      'tr': 'Turco',
      'uk': 'Ucraino',
      'ur': 'Urdu',
      'uz': 'Uzbeco',
      'vi': 'Vietnamita',
      'cy': 'Gallese',
      'xh': 'Xhosa',
      'yi': 'Yiddish',
      'yo': 'Yoruba',
      'zu': 'Zulu'
    },
    zh: {
      'auto': '检测语言',
      'af': '南非荷兰语',
      'sq': '阿尔巴尼亚语',
      'am': '阿姆哈拉语',
      'ar': '阿拉伯语',
      'hy': '亚美尼亚语',
      'az': '阿塞拜疆语',
      'eu': '巴斯克语',
      'be': '白俄罗斯语',
      'bn': '孟加拉语',
      'bs': '波斯尼亚语',
      'bg': '保加利亚语',
      'ca': '加泰罗尼亚语',
      'ceb': '宿务语',
      'ny': '齐切瓦语',
      'zh': '中文（简体）',
      'zh-TW': '中文（繁体）',
      'co': '科西嘉语',
      'hr': '克罗地亚语',
      'cs': '捷克语',
      'da': '丹麦语',
      'nl': '荷兰语',
      'en': '英语',
      'eo': '世界语',
      'et': '爱沙尼亚语',
      'tl': '菲律宾语',
      'fi': '芬兰语',
      'fr': '法语',
      'fy': '弗里西亚语',
      'gl': '加利西亚语',
      'ka': '格鲁吉亚语',
      'de': '德语',
      'el': '希腊语',
      'gu': '古吉拉特语',
      'ht': '海地克里奥尔语',
      'ha': '豪萨语',
      'haw': '夏威夷语',
      'iw': '希伯来语',
      'hi': '印地语',
      'hmn': '苗语',
      'hu': '匈牙利语',
      'is': '冰岛语',
      'ig': '伊博语',
      'id': '印尼语',
      'ga': '爱尔兰语',
      'it': '意大利语',
      'ja': '日语',
      'jw': '爪哇语',
      'kn': '卡纳达语',
      'kk': '哈萨克语',
      'km': '高棉语',
      'ko': '韩语',
      'ku': '库尔德语',
      'ky': '吉尔吉斯语',
      'lo': '老挝语',
      'la': '拉丁语',
      'lv': '拉脱维亚语',
      'lt': '立陶宛语',
      'lb': '卢森堡语',
      'mk': '马其顿语',
      'mg': '马尔加什语',
      'ms': '马来语',
      'ml': '马拉雅拉姆语',
      'mt': '马耳他语',
      'mi': '毛利语',
      'mr': '马拉地语',
      'mn': '蒙古语',
      'my': '缅甸语',
      'ne': '尼泊尔语',
      'no': '挪威语',
      'ps': '普什图语',
      'fa': '波斯语',
      'pl': '波兰语',
      'pt': '葡萄牙语',
      'pa': '旁遮普语',
      'ro': '罗马尼亚语',
      'ru': '俄语',
      'sm': '萨摩亚语',
      'gd': '苏格兰盖尔语',
      'sr': '塞尔维亚语',
      'st': '塞索托语',
      'sn': '修纳语',
      'sd': '信德语',
      'si': '僧伽罗语',
      'sk': '斯洛伐克语',
      'sl': '斯洛文尼亚语',
      'so': '索马里语',
      'es': '西班牙语', // Removed all Spanish variants
      'su': '巽他语',
      'sw': '斯瓦希里语',
      'sv': '瑞典语',
      'tg': '塔吉克语',
      'ta': '泰米尔语',
      'te': '泰卢固语',
      'th': '泰语',
      'tr': '土耳其语',
      'uk': '乌克兰语',
      'ur': '乌尔都语',
      'uz': '乌兹别克语',
      'vi': '越南语',
      'cy': '威尔士语',
      'xh': '科萨语',
      'yi': '意第绪语',
      'yo': '约鲁巴语',
      'zu': '祖鲁语'
    },
    ja: {
      'auto': '言語を検出',
      'af': 'アフリカーンス語',
      'sq': 'アルバニア語',
      'am': 'アムハラ語',
      'ar': 'アラビア語',
      'hy': 'アルメニア語',
      'az': 'アゼルバイジャン語',
      'eu': 'バスク語',
      'be': 'ベラルーシ語',
      'bn': 'ベンガル語',
      'bs': 'ボスニア語',
      'bg': 'ブルガリア語',
      'ca': 'カタルーニャ語',
      'ceb': 'セブアノ語',
      'ny': 'チェワ語',
      'zh': '中国語（簡体字）',
      'zh-TW': '中国語（繁体字）',
      'co': 'コルシカ語',
      'hr': 'クロアチア語',
      'cs': 'チェコ語',
      'da': 'デンマーク語',
      'nl': 'オランダ語',
      'en': '英語',
      'eo': 'エスペラント語',
      'et': 'エストニア語',
      'tl': 'フィリピン語',
      'fi': 'フィンランド語',
      'fr': 'フランス語',
      'fy': 'フリジア語',
      'gl': 'ガリシア語',
      'ka': 'ジョージア語',
      'de': 'ドイツ語',
      'el': 'ギリシャ語',
      'gu': 'グジャラト語',
      'ht': 'ハイチクリオール語',
      'ha': 'ハウサ語',
      'haw': 'ハワイ語',
      'iw': 'ヘブライ語',
      'hi': 'ヒンディー語',
      'hmn': 'モン語',
      'hu': 'ハンガリー語',
      'is': 'アイスランド語',
      'ig': 'イボ語',
      'id': 'インドネシア語',
      'ga': 'アイルランド語',
      'it': 'イタリア語',
      'ja': '日本語',
      'jw': 'ジャワ語',
      'kn': 'カンナダ語',
      'kk': 'カザフ語',
      'km': 'クメール語',
      'ko': '韓国語',
      'ku': 'クルド語',
      'ky': 'キルギス語',
      'lo': 'ラオ語',
      'la': 'ラテン語',
      'lv': 'ラトビア語',
      'lt': 'リトアニア語',
      'lb': 'ルクセンブルク語',
      'mk': 'マケドニア語',
      'mg': 'マダガスカル語',
      'ms': 'マレー語',
      'ml': 'マラヤーラム語',
      'mt': 'マルタ語',
      'mi': 'マオリ語',
      'mr': 'マラーティー語',
      'mn': 'モンゴル語',
      'my': 'ミャンマー語',
      'ne': 'ネパール語',
      'no': 'ノルウェー語',
      'ps': 'パシュト語',
      'fa': 'ペルシャ語',
      'pl': 'ポーランド語',
      'pt': 'ポルトガル語',
      'pa': 'パンジャブ語',
      'ro': 'ルーマニア語',
      'ru': 'ロシア語',
      'sm': 'サモア語',
      'gd': 'スコットランドゲール語',
      'sr': 'セルビア語',
      'st': 'セソト語',
      'sn': 'ショナ語',
      'sd': 'シンド語',
      'si': 'シンハラ語',
      'sk': 'スロバキア語',
      'sl': 'スロベニア語',
      'so': 'ソマリ語',
      'es': 'スペイン語', // Removed all Spanish variants
      'su': 'スンダ語',
      'sw': 'スワヒリ語',
      'sv': 'スウェーデン語',
      'tg': 'タジク語',
      'ta': 'タミル語',
      'te': 'テルグ語',
      'th': 'タイ語',
      'tr': 'トルコ語',
      'uk': 'ウクライナ語',
      'ur': 'ウルドゥー語',
      'uz': 'ウズベク語',
      'vi': 'ベトナム語',
      'cy': 'ウェールズ語',
      'xh': 'コサ語',
      'yi': 'イディッシュ語',
      'yo': 'ヨルバ語',
      'zu': 'ズールー語'
    },
    ko: {
      'auto': '언어 감지',
      'af': '아프리칸스어',
      'sq': '알바니아어',
      'am': '암하라어',
      'ar': '아랍어',
      'hy': '아르메니아어',
      'az': '아제르바이잔어',
      'eu': '바스크어',
      'be': '벨라루스어',
      'bn': '벵골어',
      'bs': '보스니아어',
      'bg': '불가리아어',
      'ca': '카탈루냐어',
      'ceb': '세부아노어',
      'ny': '치체와어',
      'zh': '중국어 (간체)',
      'zh-TW': '중국어 (번체)',
      'co': '코르시카어',
      'hr': '크로아티아어',
      'cs': '체코어',
      'da': '덴마크어',
      'nl': '네덜란드어',
      'en': '영어',
      'eo': '에스페란토어',
      'et': '에스토니아어',
      'tl': '필리핀어',
      'fi': '핀란드어',
      'fr': '프랑스어',
      'fy': '프리지아어',
      'gl': '갈리시아어',
      'ka': '조지아어',
      'de': '독일어',
      'el': '그리스어',
      'gu': '구자라트어',
      'ht': '아이티 크리올어',
      'ha': '하우사어',
      'haw': '하와이어',
      'iw': '히브리어',
      'hi': '힌디어',
      'hmn': '몽족어',
      'hu': '헝가리어',
      'is': '아이슬란드어',
      'ig': '이그보어',
      'id': '인도네시아어',
      'ga': '아일랜드어',
      'it': '이탈리아어',
      'ja': '일본어',
      'jw': '자바어',
      'kn': '칸나다어',
      'kk': '카자흐어',
      'km': '크메르어',
      'ko': '한국어',
      'ku': '쿠르드어',
      'ky': '키르기스어',
      'lo': '라오어',
      'la': '라틴어',
      'lv': '라트비아어',
      'lt': '리투아니아어',
      'lb': '룩셈부르크어',
      'mk': '마케도니아어',
      'mg': '마다가스카르어',
      'ms': '말레이어',
      'ml': '말라얄람어',
      'mt': '몰타어',
      'mi': '마오리어',
      'mr': '마라티어',
      'mn': '몽골어',
      'my': '미얀마어',
      'ne': '네팔어',
      'no': '노르웨이어',
      'ps': '파슈토어',
      'fa': '페르시아어',
      'pl': '폴란드어',
      'pt': '포르투갈어',
      'pa': '펀자브어',
      'ro': '루마니아어',
      'ru': '러시아어',
      'sm': '사모아어',
      'gd': '스코틀랜드 게일어',
      'sr': '세르비아어',
      'st': '세소토어',
      'sn': '쇼나어',
      'sd': '신디어',
      'si': '싱할라어',
      'sk': '슬로바키아어',
      'sl': '슬로베니아어',
      'so': '소말리어',
      'es': '스페인어', // Removed all Spanish variants
      'su': '순다어',
      'sw': '스와힐리어',
      'sv': '스웨덴어',
      'tg': '타지크어',
      'ta': '타밀어',
      'te': '텔루구어',
      'th': '태국어',
      'tr': '터키어',
      'uk': '우크라이나어',
      'ur': '우르두어',
      'uz': '우즈베크어',
      'vi': '베트남어',
      'cy': '웨일스어',
      'xh': '코사어',
      'yi': '이디시어',
      'yo': '요루바어',
      'zu': '줄루어'
    },
    pl: {
      'auto': 'Wykryj język',
      'af': 'Afrikaans',
      'sq': 'Albański',
      'am': 'Amharski',
      'ar': 'Arabski',
      'hy': 'Armeński',
      'az': 'Azerbejdżański',
      'eu': 'Baskijski',
      'be': 'Białoruski',
      'bn': 'Bengalski',
      'bs': 'Bośniacki',
      'bg': 'Bułgarski',
      'ca': 'Kataloński',
      'ceb': 'Cebuano',
      'ny': 'Chichewa',
      'zh': 'Chiński (uproszczony)',
      'zh-TW': 'Chiński (tradycyjny)',
      'co': 'Korsykański',
      'hr': 'Chorwacki',
      'cs': 'Czeski',
      'da': 'Duński',
      'nl': 'Holenderski',
      'en': 'Angielski',
      'eo': 'Esperanto',
      'et': 'Estoński',
      'tl': 'Filipino',
      'fi': 'Fiński',
      'fr': 'Francuski',
      'fy': 'Fryzyjski',
      'gl': 'Galicyjski',
      'ka': 'Gruziński',
      'de': 'Niemiecki',
      'el': 'Grecki',
      'gu': 'Gudżarati',
      'ht': 'Kreolski haitański',
      'ha': 'Hausa',
      'haw': 'Hawajski',
      'iw': 'Hebrajski',
      'hi': 'Hindi',
      'hmn': 'Hmong',
      'hu': 'Węgierski',
      'is': 'Islandzki',
      'ig': 'Igbo',
      'id': 'Indonezyjski',
      'ga': 'Irlandzki',
      'it': 'Włoski',
      'ja': 'Japoński',
      'jw': 'Jawajski',
      'kn': 'Kannada',
      'kk': 'Kazachski',
      'km': 'Khmerski',
      'ko': 'Koreański',
      'ku': 'Kurdyjski',
      'ky': 'Kirgiski',
      'lo': 'Laotański',
      'la': 'Łaciński',
      'lv': 'Łotewski',
      'lt': 'Litewski',
      'lb': 'Luksemburski',
      'mk': 'Macedoński',
      'mg': 'Malgaski',
      'ms': 'Malajski',
      'ml': 'Malayalam',
      'mt': 'Maltański',
      'mi': 'Maoryski',
      'mr': 'Marathi',
      'mn': 'Mongolski',
      'my': 'Birmański',
      'ne': 'Nepalski',
      'no': 'Norweski',
      'ps': 'Paszto',
      'fa': 'Perski',
      'pl': 'Polski',
      'pt': 'Portugalski',
      'pa': 'Pendżabski',
      'ro': 'Rumuński',
      'ru': 'Rosyjski',
      'sm': 'Samoański',
      'gd': 'Szkocki gaelicki',
      'sr': 'Serbski',
      'st': 'Sesotho',
      'sn': 'Shona',
      'sd': 'Sindhi',
      'si': 'Syngaleski',
      'sk': 'Słowacki',
      'sl': 'Słoweński',
      'so': 'Somalijski',
      'es': 'Hiszpański', // Removed all Spanish variants
      'su': 'Sundajski',
      'sw': 'Suahili',
      'sv': 'Szwedzki',
      'tg': 'Tadżycki',
      'ta': 'Tamilski',
      'te': 'Telugu',
      'th': 'Tajski',
      'tr': 'Turecki',
      'uk': 'Ukraiński',
      'ur': 'Urdu',
      'uz': 'Uzbecki',
      'vi': 'Wietnamski',
      'cy': 'Walijski',
      'xh': 'Xhosa',
      'yi': 'Jidysz',
      'yo': 'Joruba',
      'zu': 'Zulu'
    },
    ro: {
      'auto': 'Detectează limba',
      'af': 'Afrikaans',
      'sq': 'Albaneză',
      'am': 'Amharică',
      'ar': 'Arabă',
      'hy': 'Armeană',
      'az': 'Azeră',
      'eu': 'Bască',
      'be': 'Bielorusă',
      'bn': 'Bengali',
      'bs': 'Bosniacă',
      'bg': 'Bulgară',
      'ca': 'Catalană',
      'ceb': 'Cebuano',
      'ny': 'Chichewa',
      'zh': 'Chineză (simplificată)',
      'zh-TW': 'Chineză (tradițională)',
      'co': 'Corsicană',
      'hr': 'Croată',
      'cs': 'Cehă',
      'da': 'Daneză',
      'nl': 'Olandeză',
      'en': 'Engleză',
      'eo': 'Esperanto',
      'et': 'Estonă',
      'tl': 'Filipineză',
      'fi': 'Finlandeză',
      'fr': 'Franceză',
      'fy': 'Friziană',
      'gl': 'Galiciană',
      'ka': 'Georgiană',
      'de': 'Germană',
      'el': 'Greacă',
      'gu': 'Gujarati',
      'ht': 'Creolă haitiană',
      'ha': 'Hausa',
      'haw': 'Hawaiană',
      'iw': 'Ebraică',
      'hi': 'Hindi',
      'hmn': 'Hmong',
      'hu': 'Maghiară',
      'is': 'Islandeză',
      'ig': 'Igbo',
      'id': 'Indoneziană',
      'ga': 'Irlandeză',
      'it': 'Italiană',
      'ja': 'Japoneză',
      'jw': 'Javaneză',
      'kn': 'Kannada',
      'kk': 'Kazahă',
      'km': 'Khmeră',
      'ko': 'Coreeană',
      'ku': 'Kurdă',
      'ky': 'Kârgâză',
      'lo': 'Laoțiană',
      'la': 'Latină',
      'lv': 'Letonă',
      'lt': 'Lituaniană',
      'lb': 'Luxemburgheză',
      'mk': 'Macedoneană',
      'mg': 'Malgașă',
      'ms': 'Malaeză',
      'ml': 'Malayalam',
      'mt': 'Malteză',
      'mi': 'Maori',
      'mr': 'Marathi',
      'mn': 'Mongolă',
      'my': 'Birmană',
      'ne': 'Nepaleză',
      'no': 'Norvegiană',
      'ps': 'Pașto',
      'fa': 'Persană',
      'pl': 'Poloneză',
      'pt': 'Portugheză',
      'pa': 'Punjabi',
      'ro': 'Română',
      'ru': 'Rusă',
      'sm': 'Samoană',
      'gd': 'Gaelică scoțiană',
      'sr': 'Sârbă',
      'st': 'Sesotho',
      'sn': 'Shona',
      'sd': 'Sindhi',
      'si': 'Singaleză',
      'sk': 'Slovacă',
      'sl': 'Slovenă',
      'so': 'Somaleză',
      'es': 'Spaniolă', // Removed all Spanish variants
      'su': 'Sundaneză',
      'sw': 'Swahili',
      'sv': 'Suedeză',
      'tg': 'Tadjică',
      'ta': 'Tamil',
      'te': 'Telugu',
      'th': 'Thailandeză',
      'tr': 'Turcă',
      'uk': 'Ucraineană',
      'ur': 'Urdu',
      'uz': 'Uzbecă',
      'vi': 'Vietnameză',
      'cy': 'Galeză',
      'xh': 'Xhosa',
      'yi': 'Idiș',
      'yo': 'Yoruba',
      'zu': 'Zulu'
    }
  };

  return languageTranslations[appLang] || languageTranslations['en'];
};

// Alias for backward compatibility
export const getLanguagesByInterfaceLanguage = getLanguagesByAppLanguage;

export const languages = [
  { code: 'af', name: 'Afrikaans', flag: '🇿🇦', voice: 'af-ZA' },
  { code: 'sq', name: 'Albanian', flag: '🇦🇱', voice: 'sq-AL' },
  { code: 'am', name: 'Amharic', flag: '🇪🇹', voice: 'am-ET' },
  { code: 'ar', name: 'Arabic', flag: '🇸🇦', voice: 'ar-SA' },
  { code: 'hy', name: 'Armenian', flag: '🇦🇲', voice: 'hy-AM' },
  { code: 'az', name: 'Azerbaijani', flag: '🇦🇿', voice: 'az-AZ' },
  { code: 'eu', name: 'Basque', flag: '🏴', voice: 'eu-ES' },
  { code: 'be', name: 'Belarusian', flag: '🇧🇾', voice: 'be-BY' },
  { code: 'bn', name: 'Bengali', flag: '🇧🇩', voice: 'bn-BD' },
  { code: 'bs', name: 'Bosnian', flag: '🇧🇦', voice: 'bs-BA' },
  { code: 'bg', name: 'Bulgarian', flag: '🇧🇬', voice: 'bg-BG' },
  { code: 'ca', name: 'Catalan', flag: '🏴', voice: 'ca-ES' },
  { code: 'ceb', name: 'Cebuano', flag: '🇵🇭', voice: 'ceb-PH' },
  { code: 'ny', name: 'Chichewa', flag: '🇲🇼', voice: 'ny-MW' },
  { code: 'zh', name: 'Chinese (Simplified)', flag: '🇨🇳', voice: 'zh-CN' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', flag: '🇹🇼', voice: 'zh-TW' },
  { code: 'co', name: 'Corsican', flag: '🇫🇷', voice: 'co-FR' },
  { code: 'hr', name: 'Croatian', flag: '🇭🇷', voice: 'hr-HR' },
  { code: 'cs', name: 'Czech', flag: '🇨🇿', voice: 'cs-CZ' },
  { code: 'da', name: 'Danish', flag: '🇩🇰', voice: 'da-DK' },
  { code: 'nl', name: 'Dutch', flag: '🇳🇱', voice: 'nl-NL' },
  { code: 'en', name: 'English', flag: '🇺🇸', voice: 'en-US' },
  { code: 'eo', name: 'Esperanto', flag: '🌍', voice: 'eo' },
  { code: 'et', name: 'Estonian', flag: '🇪🇪', voice: 'et-EE' },
  { code: 'tl', name: 'Filipino', flag: '🇵🇭', voice: 'tl-PH' },
  { code: 'fi', name: 'Finnish', flag: '🇫🇮', voice: 'fi-FI' },
  { code: 'fr', name: 'French', flag: '🇫🇷', voice: 'fr-FR' },
  { code: 'fy', name: 'Frisian', flag: '🇳🇱', voice: 'fy-NL' },
  { code: 'gl', name: 'Galician', flag: '🏴', voice: 'gl-ES' },
  { code: 'ka', name: 'Georgian', flag: '🇬🇪', voice: 'ka-GE' },
  { code: 'de', name: 'German', flag: '🇩🇪', voice: 'de-DE' },
  { code: 'el', name: 'Greek', flag: '🇬🇷', voice: 'el-GR' },
  { code: 'gu', name: 'Gujarati', flag: '🇮🇳', voice: 'gu-IN' },
  { code: 'ht', name: 'Haitian Creole', flag: '🇭🇹', voice: 'ht-HT' },
  { code: 'ha', name: 'Hausa', flag: '🇳🇬', voice: 'ha-NG' },
  { code: 'haw', name: 'Hawaiian', flag: '🇺🇸', voice: 'haw-US' },
  { code: 'iw', name: 'Hebrew', flag: '🇮🇱', voice: 'he-IL' },
  { code: 'hi', name: 'Hindi', flag: '🇮🇳', voice: 'hi-IN' },
  { code: 'hmn', name: 'Hmong', flag: '🇱🇦', voice: 'hmong' },
  { code: 'hu', name: 'Hungarian', flag: '🇭🇺', voice: 'hu-HU' },
  { code: 'is', name: 'Icelandic', flag: '🇮🇸', voice: 'is-IS' },
  { code: 'ig', name: 'Igbo', flag: '🇳🇬', voice: 'ig-NG' },
  { code: 'id', name: 'Indonesian', flag: '🇮🇩', voice: 'id-ID' },
  { code: 'ga', name: 'Irish', flag: '🇮🇪', voice: 'ga-IE' },
  { code: 'it', name: 'Italian', flag: '🇮🇹', voice: 'it-IT' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵', voice: 'ja-JP' },
  { code: 'jw', name: 'Javanese', flag: '🇮🇩', voice: 'jw-ID' },
  { code: 'kn', name: 'Kannada', flag: '🇮🇳', voice: 'kn-IN' },
  { code: 'kk', name: 'Kazakh', flag: '🇰🇿', voice: 'kk-KZ' },
  { code: 'km', name: 'Khmer', flag: '🇰🇭', voice: 'km-KH' },
  { code: 'ko', name: 'Korean', flag: '🇰🇷', voice: 'ko-KR' },
  { code: 'ku', name: 'Kurdish (Kurmanji)', flag: '🏴', voice: 'ku' },
  { code: 'ky', name: 'Kyrgyz', flag: '🇰🇬', voice: 'ky-KG' },
  { code: 'lo', name: 'Lao', flag: '🇱🇦', voice: 'lo-LA' },
  { code: 'la', name: 'Latin', flag: '🏛️', voice: 'la' },
  { code: 'lv', name: 'Latvian', flag: '🇱🇻', voice: 'lv-LV' },
  { code: 'lt', name: 'Lithuanian', flag: '🇱🇹', voice: 'lt-LT' },
  { code: 'lb', name: 'Luxembourgish', flag: '🇱🇺', voice: 'lb-LU' },
  { code: 'mk', name: 'Macedonian', flag: '🇲🇰', voice: 'mk-MK' },
  { code: 'mg', name: 'Malagasy', flag: '🇲🇬', voice: 'mg-MG' },
  { code: 'ms', name: 'Malay', flag: '🇲🇾', voice: 'ms-MY' },
  { code: 'ml', name: 'Malayalam', flag: '🇮🇳', voice: 'ml-IN' },
  { code: 'mt', name: 'Maltese', flag: '🇲🇹', voice: 'mt-MT' },
  { code: 'mi', name: 'Maori', flag: '🇳🇿', voice: 'mi-NZ' },
  { code: 'mr', name: 'Marathi', flag: '🇮🇳', voice: 'mr-IN' },
  { code: 'mn', name: 'Mongolian', flag: '🇲🇳', voice: 'mn-MN' },
  { code: 'my', name: 'Myanmar (Burmese)', flag: '🇲🇲', voice: 'my-MM' },
  { code: 'ne', name: 'Nepali', flag: '🇳🇵', voice: 'ne-NP' },
  { code: 'no', name: 'Norwegian', flag: '🇳🇴', voice: 'no-NO' },
  { code: 'ps', name: 'Pashto', flag: '🇦🇫', voice: 'ps-AF' },
  { code: 'fa', name: 'Persian', flag: '🇮🇷', voice: 'fa-IR' },
  { code: 'pl', name: 'Polish', flag: '🇵🇱', voice: 'pl-PL' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹', voice: 'pt-PT' },
  { code: 'pa', name: 'Punjabi', flag: '🇮🇳', voice: 'pa-IN' },
  { code: 'ro', name: 'Romanian', flag: '🇷🇴', voice: 'ro-RO' },
  { code: 'ru', name: 'Russian', flag: '🇷🇺', voice: 'ru-RU' },
  { code: 'sm', name: 'Samoan', flag: '🇼🇸', voice: 'sm-WS' },
  { code: 'gd', name: 'Scots Gaelic', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿', voice: 'gd-GB' },
  { code: 'sr', name: 'Serbian', flag: '🇷🇸', voice: 'sr-RS' },
  { code: 'st', name: 'Sesotho', flag: '🇱🇸', voice: 'st-LS' },
  { code: 'sn', name: 'Shona', flag: '🇿🇼', voice: 'sn-ZW' },
  { code: 'sd', name: 'Sindhi', flag: '🇵🇰', voice: 'sd-PK' },
  { code: 'si', name: 'Sinhala', flag: '🇱🇰', voice: 'si-LK' },
  { code: 'sk', name: 'Slovak', flag: '🇸🇰', voice: 'sk-SK' },
  { code: 'sl', name: 'Slovenian', flag: '🇸🇮', voice: 'sl-SI' },
  { code: 'so', name: 'Somali', flag: '🇸🇴', voice: 'so-SO' },
  { code: 'es', name: 'Spanish', flag: '🇨🇴', voice: 'es-ES' }, // Only one Spanish with Colombian flag
  { code: 'su', name: 'Sundanese', flag: '🇮🇩', voice: 'su-ID' },
  { code: 'sw', name: 'Swahili', flag: '🇰🇪', voice: 'sw-KE' },
  { code: 'sv', name: 'Swedish', flag: '🇸🇪', voice: 'sv-SE' },
  { code: 'tg', name: 'Tajik', flag: '🇹🇯', voice: 'tg-TJ' },
  { code: 'ta', name: 'Tamil', flag: '🇮🇳', voice: 'ta-IN' },
  { code: 'te', name: 'Telugu', flag: '🇮🇳', voice: 'te-IN' },
  { code: 'th', name: 'Thai', flag: '🇹🇭', voice: 'th-TH' },
  { code: 'tr', name: 'Turkish', flag: '🇹🇷', voice: 'tr-TR' },
  { code: 'uk', name: 'Ukrainian', flag: '🇺🇦', voice: 'uk-UA' },
  { code: 'ur', name: 'Urdu', flag: '🇵🇰', voice: 'ur-PK' },
  { code: 'uz', name: 'Uzbek', flag: '🇺🇿', voice: 'uz-UZ' },
  { code: 'vi', name: 'Vietnamese', flag: '🇻🇳', voice: 'vi-VN' },
  { code: 'cy', name: 'Welsh', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿', voice: 'cy-GB' },
  { code: 'xh', name: 'Xhosa', flag: '🇿🇦', voice: 'xh-ZA' },
  { code: 'yi', name: 'Yiddish', flag: '🏴', voice: 'yi' },
  { code: 'yo', name: 'Yoruba', flag: '🇳🇬', voice: 'yo-NG' },
  { code: 'zu', name: 'Zulu', flag: '🇿🇦', voice: 'zu-ZA' }
];